import { gql } from '@lcs/shared/api';

export const getSystemLogQuery = gql`
   query GetSystemLogRegister($first: Int!, $filters: String, $after: String, $orderingOptions: [OrderingOption!]) {
      systemLogsConnection(first: $first, filters: $filters, after: $after, orderingOptions: $orderingOptions) {
         totalCount
         pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
         }
         items {
            systemLogId
            message
            severityId
            severityName
            typeId
            typeName
            areaId
            areaName
            logCode
            account {
               accountId
               name
            }
            callDetail {
               callDetailId
               callDirectionTypeId
               callSegmentsConnection {
                  items {
                     callSegmentId
                     callDetailId
                     sourceExtensionId
                     extensionId
                     sourceExtension {
                        extensionId
                        extensionType {
                           name
                        }
                        name
                        number
                     }
                     extension {
                        extensionId
                        extensionType {
                           name
                        }
                        name
                        number
                     }
                     startDate
                     duration
                  }
               }
               destinationExtension {
                  extensionId
                  number
                  name
               }
               destinationNumber
               originalDestinationNumber
               phoneNumber {
                  phoneNumberId
                  phoneNumber
               }
               serverName
               startTime
               endTime
               sipCallId
               sourceExtension {
                  extensionId
                  number
                  name
               }
               sourceNumber
            }
            createUserDate
            createUser {
               userId
               name
            }
         }
      }
   }
`;
